// extracted by mini-css-extract-plugin
export default {"root":"Hero_root__rRRpB","bgImage":"Hero_bgImage__Z1iTb","text":"Hero_text__X++LG","title":"Hero_title__CIHi8","image":"Hero_image__yit2w","banner":"Hero_banner__vd6lY"};